module.exports = __webpack_public_path__ + "img/onloadpicin.png";